"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = void 0;
var _reportData = _interopRequireDefault(require("../../../redux/dashboard/reportData/reportData/reportData.reducer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var serviceURL = "/reportdataservice/v1/api/report/data";
var config = {
  fund: serviceURL + "/fund",
  donors: serviceURL + "/donors",
  impact: serviceURL + "/impact",
  performance: serviceURL + "/performance",
  fundType: serviceURL + "/fund/type",
  impactType: serviceURL + "/impact/type",
  reportingYear: serviceURL + "/report/year",
  year: serviceURL + "/year",
  reportData: serviceURL + "/impact"
};
exports.config = config;